import React, { useState, useRef, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import {
  getBranches,
  fetchRoles,
  submitCustomer,
} from "../redux/slices/Customer/CreateCustomerSlice";
import { fetchUserProfile } from "../redux/slices/branch/userProfileSlice";
import "../assets/css/customerForm.css";
import { FaCheckCircle, FaSpinner } from "react-icons/fa";
import { toast } from "react-toastify";
import axios from "axios";

/* ================= AUTO HELPERS ================= */

// const fetchAddressByPincode = async (pincode) => {
//   if (!/^\d{6}$/.test(pincode)) return null;
//   try {
//     const res = await fetch(`https://payyug.in/api/customer/pincode/${pincode}`);
//     const data = await res.json();
//     const offices = data?.[0]?.PostOffice;
//     // console.log("pin details:",data)
//     if (!offices || offices.length === 0) return null;

//     return {
//       postOfficeList: offices,
//       district: offices[0].District,
//       subDistrict: offices[0].Block || "",
//       state: offices[0].State,
//       country: offices[0].Country,
//     };
//   } catch {
//     return null;
//   }
// };

const fetchAddressByPincode = async (pincode) => {
  if (!/^\d{6}$/.test(pincode)) return null;

  try {
    const res = await fetch(
      `https://payyug.in/api/customer/pincode/${pincode}`,
    );

    const response = await res.json();

    console.log("PINCODE RESPONSE:", response);

    // ✅ Get PostOffice array
    const offices = response?.PostOffice;

    // ✅ Validate response
    if (!offices || offices.length === 0) {
      return null;
    }

    return {
      postOfficeList: offices,
      district: offices[0]?.District || "",
      subDistrict: offices[0]?.Block || "",
      state: offices[0]?.State || "",
      country: offices[0]?.Country || "",
    };
  } catch (error) {
    console.log("Pincode Fetch Error:", error);

    return null;
  }
};

const fetchBankByIFSC = async (ifsc) => {
  if (!/^[A-Z]{4}0[A-Z0-9]{6}$/.test(ifsc)) return null;
  try {
    const res = await fetch(`https://ifsc.razorpay.com/${ifsc}`);
    if (!res.ok) return null;
    const data = await res.json();
    // console.log("bank details;",data)
    return { bankName: data.BANK, bankBranch: data.BRANCH };
  } catch {
    return null;
  }
};

const CustomerForm = () => {
  const dispatch = useDispatch();
  const { branches, roles, loadingSubmit } = useSelector(
    (state) => state.customer,
  );
  const { profile } = useSelector((state) => state.userProfile);

  const [formData, setFormData] = useState({});
  const [errors, setErrors] = useState({});
  const [firstErrorField, setFirstErrorField] = useState(null);
  const [postOfficeList, setPostOfficeList] = useState([]);
  const [verifying, setVerifying] = useState({
    panNumber: false,
    aadhaarNumber: false,
  });

  const [verified, setVerified] = useState({
    panNumber: false,
    aadhaarNumber: false,
  });

  const firstErrorRef = useRef(null);

  useEffect(() => {
    dispatch(getBranches());
    dispatch(fetchRoles());
    dispatch(fetchUserProfile());
  }, [dispatch]);

  useEffect(() => {
    // scroll to the first error when firstErrorField changes
    if (firstErrorField && firstErrorRef.current) {
      firstErrorRef.current.scrollIntoView({
        behavior: "smooth",
        block: "center",
      });
    }
  }, [firstErrorField]);

  // const handleChange = async (e) => {
  //   const { name, value } = e.target;
  //   // restrict pincode to 6 chars
  //   if (name === "pincode" && value.length > 6) return;

  //   // restrict mobile to 10 digits
  //   if (name === "mobileNumber" && value.length > 10) return;

  //   // restrict aadhaar to 12 digits
  //   if (name === "aadhaarNumber" && value.length > 12) return;

  //   // restrict pan to 10 chars
  //   if (name === "panNumber" && value.length > 10) return;

  //   const val =
  //     name === "ifsc" || name === "panNumber" ? value.toUpperCase() : value;

  //   setFormData((p) => ({ ...p, [name]: val }));

  //   // PINCODE AUTO
  //   if (name === "pincode" && val.length === 6) {
  //     const addr = await fetchAddressByPincode(val);
  //     if (addr) {
  //       setPostOfficeList(addr.postOfficeList);
  //       setFormData((p) => ({
  //         ...p,
  //         district: addr.district,
  //         state: addr.state,
  //         country: addr.country,
  //         subDistrict: addr.subDistrict,
  //         postOffice: "",
  //       }));
  //     }
  //   }

  //   // IFSC AUTO
  //   if (name === "ifsc") {
  //     const bank = await fetchBankByIFSC(val);
  //     setFormData((p) => ({
  //       ...p,
  //       bankName: bank?.bankName || "",
  //       bankBranch: bank?.bankBranch || "",
  //     }));
  //   }
  // };

  const handleChange = async (e) => {
    const { name, value } = e.target;

    // restrictions
    if (name === "pincode" && value.length > 6) return;
    if (name === "mobileNumber" && value.length > 10) return;
    if (name === "aadhaarNumber" && value.length > 12) return;
    if (name === "panNumber" && value.length > 10) return;

    // ❗ Fields you want in uppercase
    const upperCaseFields = [
      "panNumber",
      "ifsc",
      // "fullName",
      // "guardianName",
      // "district",
      // "state",
      // "country",
      // "subDistrict",
      // "bankName",
      // "bankBranch",
      // "address",
    ];

    const val = upperCaseFields.includes(name) ? value.toUpperCase() : value;

    setFormData((p) => ({ ...p, [name]: val }));

    // PINCODE AUTO
    if (name === "pincode" && val.length === 6) {
      const addr = await fetchAddressByPincode(val);
      if (addr) {
        setPostOfficeList(addr.postOfficeList);
        setFormData((p) => ({
          ...p,
          district: addr.district.toUpperCase(),
          state: addr.state.toUpperCase(),
          country: addr.country.toUpperCase(),
          subDistrict: addr.subDistrict?.toUpperCase() || "",
          postOffice: "",
        }));
      }
    }

    // IFSC AUTO
    if (name === "ifsc") {
      const bank = await fetchBankByIFSC(val);
      setFormData((p) => ({
        ...p,
        bankName: bank?.bankName?.toUpperCase() || "",
        bankBranch: bank?.bankBranch?.toUpperCase() || "",
      }));
    }
  };

  const handlePostOfficeSelect = (e) => {
    setFormData((p) => ({ ...p, postOffice: e.target.value }));
  };

  // handle Verify
  // const handleVerify = async (field) => {
  //   try {
  //     // 🔹 basic validation before verification
  //     if (field === "panNumber") {
  //       if (!formData.panNumber) {
  //         toast.warn("Please enter PAN number first");
  //         return;
  //       }

  //       if (!/^[A-Z]{5}[0-9]{4}[A-Z]$/.test(formData.panNumber)) {
  //         toast.warn("Invalid PAN format (ABCDE1234F)");
  //         return;
  //       }
  //     }

  //     if (field === "aadhaarNumber") {
  //       if (!formData.aadhaarNumber) {
  //         toast.warn("Please enter Aadhaar number first");
  //         return;
  //       }

  //       if (!/^[2-9][0-9]{11}$/.test(formData.aadhaarNumber)) {
  //         toast.warn("Invalid Aadhaar number (12 digits)");
  //         return;
  //       }
  //     }

  //     // 🔹 start verification loader
  //     setVerifying((p) => ({ ...p, [field]: true }));

  //     // 🔹 simulate API call delay
  //     await new Promise((resolve) => setTimeout(resolve, 1500));

  //     // 🔹 mock success (you can replace with real API later)
  //     setVerified((p) => ({ ...p, [field]: true }));

  //     toast.success(
  //       `✅ ${field === "panNumber" ? "PAN" : "Aadhaar"} verified successfully`
  //     );
  //   } catch (error) {
  //     console.error("Verification error:", error);
  //     toast.error(
  //       `❌ ${field === "panNumber" ? "PAN" : "Aadhaar"} verification failed`
  //     );
  //   } finally {
  //     // 🔹 stop loader
  //     setVerifying((p) => ({ ...p, [field]: false }));
  //   }
  // };

  // Validation
  const validateForm = () => {
    const newErr = {};

    // PAN: 5 letters + 4 digits + 1 letter
    if (
      formData.panNumber &&
      !/^[A-Z]{5}[0-9]{4}[A-Z]{1}$/i.test(formData.panNumber.trim())
    ) {
      newErr.panNumber = "Enter a valid PAN (format: ABCDE1234F).";
    }

    // Aadhaar: 12 digits and should not start with 0 or 1
    if (
      !formData.aadhaarNumber ||
      !/^[2-9][0-9]{11}$/.test(formData.aadhaarNumber.trim())
    )
      newErr.aadhaarNumber =
        "Enter a valid Aadhaar (12 digits, cannot start with 0 or 1).";

    // IFSC: optional but validate if present
    if (formData.ifsc && !/^[A-Z]{4}0[A-Z0-9]{6}$/.test(formData.ifsc.trim()))
      newErr.ifsc = "Invalid IFSC code.";

    // Mobile: Indian mobile (starts with 6-9 and 10 digits)
    if (
      !formData.mobileNumber ||
      !/^[6-9][0-9]{9}$/.test(formData.mobileNumber.trim())
    )
      newErr.mobileNumber =
        "Enter a valid 10-digit mobile number (starts with 6-9).";

    // Bank account: optional but validate if present (9-18 digits)
    if (
      formData.bankAccount &&
      !/^[0-9]{9,18}$/.test(formData.bankAccount.trim())
    )
      newErr.bankAccount = "Enter valid bank account number (9-18 digits).";

    // Pincode: required and 6 digits
    if (!formData.pincode || !/^[0-9]{6}$/.test(formData.pincode.trim()))
      newErr.pincode = "Enter a valid 6-digit pincode.";

    // Required textual fields
    const requiredFields = [
      "fullName",
      "guardianName",
      "district",
      "state",
      "country",
      "dob",
      "doj",
    ];
    requiredFields.forEach((f) => {
      if (!formData[f] || String(formData[f]).trim() === "")
        newErr[f] = "Required field.";
    });

    // Email: optional but validate format if provided
    if (formData.email && !/\S+@\S+\.\S+/.test(formData.email.trim()))
      newErr.email = "Enter a valid email.";

    setErrors(newErr);

    if (Object.keys(newErr).length) {
      setFirstErrorField(Object.keys(newErr)[0]);
      return false;
    }

    // no errors
    setFirstErrorField(null);
    return true;
  };

  // const handleSubmit = async () => {
  //   if (!validateForm()) return;

  //   const payload = {
  //     ...formData,
  //     branchId: profile?.id || formData.branchId || 1,
  //     branchName: formData.branch || "",
  //     superAdminId: profile?.superAdminId || 1,
  //     role: "Customer",
  //     roleName: "Customer",
  //     bankIFSC: formData.ifsc || null,
  //     dateOfBirth: formData.dob,
  //     dateOfJoining: formData.doj,
  //     password: "123456",
  //     pin: "1234",
  //   };

  //   // Clean up fields expected by backend
  //   delete payload.ifsc;
  //   delete payload.branch;
  //   delete payload.dob;
  //   delete payload.doj;

  //   try {
  //     const result = await dispatch(submitCustomer(payload)).unwrap();
  //     alert("✅ Customer submitted successfully!");
  //     console.log("Response:", result);

  //     // reset form
  //     setFormData({
  //       panNumber: "",
  //       aadhaarNumber: "",
  //       branch: "",
  //       title: "",
  //       gender: "",
  //       fullName: "",
  //       guardianName: "",
  //       mobileNumber: "",
  //       email: "",
  //       pincode: "",
  //       postOffice: "",
  //       bankAccount: "",
  //       ifsc: "",
  //       bankBranch: "",
  //       bankName: "",
  //       subDistrict: "",
  //       district: "",
  //       state: "",
  //       country: "",
  //       address: "",
  //       maritalStatus: "",
  //       dob: "",
  //       doj: "",
  //     });
  //     setErrors({});
  //     setFirstErrorField(null);
  //   } catch (err) {
  //     console.error("❌ Error submitting customer:", err);
  //     // unwrap error might be object/string; handle gracefully
  //     const msg = err?.message || err || "Failed to submit customer";
  //     alert(msg);
  //   }
  // };

  const handleSubmit = async () => {
    if (!validateForm()) return;

    const payload = {
      ...formData,
      branchId: profile?.id || formData.branchId || 1,
      branchName: formData.branch || "",
      superAdminId: profile?.superAdminId || 1,
      role: "Customer",
      roleName: "Customer",
      bankIFSC: formData.ifsc || null,
      dateOfBirth: formData.dob,
      dateOfJoining: formData.doj,
      password: "123456",
      pin: "1234",
    };

    // Clean up unused fields
    delete payload.ifsc;
    delete payload.branch;
    delete payload.dob;
    delete payload.doj;

    try {
      // ⬅ 1. Submit customer API
      const result = await dispatch(submitCustomer(payload)).unwrap();

      toast.success("✅ Customer submitted successfully!");
      console.log("Response:", result);

      // Extract required fields for SMS
      const { fullName, userId, mobileNumber } = result?.data || result;

      // // ⬅ 2. SMS Body
      // const smsBody = {
      //   route: "dlt",
      //   sender_id: "LALSHA",
      //   message: "180723", // DLT template ID
      //   variables_values: ${fullName}|${userId}|,
      //   numbers: mobileNumber,
      // };

      // // ⬅ 3. Hit Fast2SMS API
      // try {
      //   await axios.post("https://www.fast2sms.com/dev/bulkV2", smsBody, {
      //     headers: {
      //       Authorization: "4jzl3TwEqtSk78bCxgRIUZKAFmnMivBy1o2fdpPGOYu69aVreJjLE3o27nJfpwPKIzqmaD9ilNx1dtZ8", // Store securely in .env
      //     },
      //   });

      //   console.log("📩 SMS Sent Successfully");
      // } catch (smsError) {
      //   console.error(
      //     "❌ SMS Sending Failed:",
      //     smsError.response?.data || smsError.message
      //   );
      // }

      // Reset Form after success
      setFormData({
        panNumber: "",
        aadhaarNumber: "",
        branch: "",
        title: "",
        gender: "",
        fullName: "",
        guardianName: "",
        mobileNumber: "",
        email: "",
        pincode: "",
        postOffice: "",
        bankAccount: "",
        ifsc: "",
        bankBranch: "",
        bankName: "",
        subDistrict: "",
        district: "",
        state: "",
        country: "",
        address: "",
        maritalStatus: "",
        dob: "",
        doj: "",
      });

      setErrors({});
      setFirstErrorField(null);
    } catch (err) {
      console.error("❌ Error submitting customer:", err);

      const msg = err?.message || err || "Failed to submit customer";
      alert(msg);
    }
  };

  const classErr = (f) => (errors[f] ? "CreateEmployee-input-error" : "");
  const renderError = (f) =>
    errors[f] ? (
      <p
        className="CreateEmployee-error-text"
        // attach ref only to the first error's element so scrollIntoView works
        ref={firstErrorField === f ? firstErrorRef : null}
      >
        {errors[f]}
      </p>
    ) : null;

  // const handlePostOfficeSelect = (e) => {
  //   setFormData({
  //     ...formData,
  //     postOffice: e.target.value,
  //   });
  // };

  //   const handleVerifyAdhar = async () => {
  //   const payload = { uid: profile?.superAdminId };

  //   try {
  //     const response = await axios.post('https://payyug.in/api/initiate/aadhar', payload);

  //     const url = response.data?.data?.data?.authorization_url;

  //     if (url) {
  //       window.open(url, '_blank', 'noopener,noreferrer');
  //     } else {
  //       toast.error(response?.data?.message||"Url doesn't exist.");
  //     }
  //   } catch (error) {
  //     console.error("API Error:", error.response?.data || error.message);
  //     toast.error(error?.response?.data?.message||"Something went wrong, please try again.");
  //   }
  // };

  const handleVerifyAadhaar = async () => {
    if (
      !formData.aadhaarNumber ||
      !/^[2-9][0-9]{11}$/.test(formData.aadhaarNumber)
    ) {
      toast.warn("Please enter a valid 12-digit Aadhaar number");
      return;
    }
    setVerifying((p) => ({ ...p, aadhaarNumber: true }));
    try {
      const response = await axios.post(
        "https://payyug.in/api/initiate/aadhar",
        { uid: profile?.superAdminId },
      );
      const url = response.data?.data?.data?.authorization_url;
      if (url) {
        window.open(url, "_blank", "noopener,noreferrer");
        setVerified((p) => ({ ...p, aadhaarNumber: true }));
        toast.success("Aadhaar verification initiated");
      } else {
        toast.error(response?.data?.message || "Url doesn't exist.");
      }
    } catch (error) {
      toast.error(error?.response?.data?.message || "Something went wrong.");
    } finally {
      setVerifying((p) => ({ ...p, aadhaarNumber: false }));
    }
  };

  const handleVerifyPan = async () => {
    if (
      !formData.panNumber ||
      !/^[A-Z]{5}[0-9]{4}[A-Z]$/.test(formData.panNumber)
    ) {
      toast.warn("Invalid PAN format");
      return;
    }

    setVerifying((p) => ({ ...p, panNumber: true }));

    try {
      const response = await axios.post(
        "https://payyug.in/api/verify/pan-new",
        { adminId: profile?.superAdminId, pan_number: formData.panNumber },
      );

      const data = response?.data?.data;

      if (data) {
        setFormData((prev) => ({
          ...prev,
          fullName: data?.name || prev?.fullName,
          dob: data?.dob || prev.dob,
          // pincode: data?.address?.zip || "",
          gender: data?.gender,
        }));

        setVerified((p) => ({ ...p, panNumber: true }));
        toast.success(response?.data?.message || "PAN Verified");
      } else {
        toast.error("No data found for this PAN.");
      }
    } catch (error) {
      console.error("PAN Error:", error);
      toast.error(error?.response?.data?.error || "Something went wrong.");
    } finally {
      setVerifying((p) => ({ ...p, panNumber: false }));
    }
  };

  return (
    <div className="CustomerForm-wrapper">
      <form className="CustomerForm" onSubmit={(e) => e.preventDefault()}>
        <h2 className="form-title">Create New Customer</h2>
        {/* <div className="verify-btns-wrapper">
          <button className="">Verify Pan</button>
          <button className="" onClick={handleVerifyAdhar}>Verify Aadhar</button>
        </div> */}

        {/* Personal Info */}
        <section className="form-section">
          <h3 className="section-title">Personal Information</h3>

          <div className="form-grid-2">
            <div className="verify-wrapper">
              <label>PAN Number</label>
              <div className="verify-input-group">
                <input
                  type="text"
                  name="panNumber"
                  value={formData.panNumber || ""}
                  onChange={handleChange}
                  placeholder="Enter PAN Number"
                />
                <button
                  type="button"
                  className="verify-btn"
                  onClick={handleVerifyPan}
                  // disabled={
                  //   !formData.panNumber ||
                  //   verifying.panNumber ||
                  //   verified.panNumber
                  // }
                  disabled
                  style={{}}
                >
                  {verifying.panNumber ? (
                    <FaSpinner className="spin" />
                  ) : verified.panNumber ? (
                    "Verified ✅"
                  ) : (
                    <>
                      <FaCheckCircle /> Verify
                    </>
                  )}
                </button>
              </div>
              {renderError("panNumber")}
            </div>

            <div className="verify-wrapper">
              <label>Aadhaar Number</label>
              <div className="verify-input-group">
                <input
                  type="text"
                  name="aadhaarNumber"
                  value={formData.aadhaarNumber || ""}
                  onChange={handleChange}
                  placeholder="Enter Aadhaar Number"
                />
                <button
                  type="button"
                  className="verify-btn"
                  onClick={handleVerifyAadhaar}
                  // disabled={!formData.aadhaarNumber ||verifying.aadhaarNumber || verified.aadhaarNumber}
                  disabled
                >
                  {verifying.aadhaarNumber ? (
                    <FaSpinner className="spin" />
                  ) : verified.aadhaarNumber ? (
                    "Verified ✅"
                  ) : (
                    <>
                      <FaCheckCircle /> Verify
                    </>
                  )}
                </button>
              </div>
              {verified.aadhaarNumber && (
                <div className="verified-data-box">
                  <h4 className="verified-heading">Aadhaar Verified Data:-</h4>
                  <div className="verified-grid">
                    <p>
                      <strong>Status:</strong> Verified Successfully ✅
                    </p>
                  </div>
                </div>
              )}
              {renderError("aadhaarNumber")}
            </div>
          </div>

          <div className="form-grid-4">
            <div>
              <label>Title</label>
              <select
                name="title"
                value={formData.title || ""}
                onChange={handleChange}
              >
                <option value="">Select Title</option>
                <option>Mr.</option>
                <option>Mrs.</option>
                <option>Ms.</option>
                <option>Miss</option>
                <option>Dr.</option>
              </select>
            </div>

            <div>
              <label>Gender</label>
              <select
                name="gender"
                value={formData.gender || ""}
                onChange={handleChange}
              >
                <option value="">Select Gender</option>
                <option>Male</option>
                <option>Female</option>
                <option>Other</option>
              </select>
            </div>
          </div>
        </section>

        {/* Contact & Banking */}
        <section className="form-section">
          <h3 className="section-title">Contact & Banking</h3>
          <div className="form-grid">
            <div>
              <label>Full Name</label>
              <input
                name="fullName"
                value={formData.fullName || ""}
                onChange={handleChange}
                className={classErr("fullName")}
              />
              {renderError("fullName")}
            </div>

            <div>
              <label>Parent's Name</label>
              <input
                name="guardianName"
                value={formData.guardianName || ""}
                onChange={handleChange}
                className={classErr("guardianName")}
              />
              {renderError("guardianName")}
            </div>

            <div>
              <label>Mobile Number</label>
              <input
                name="mobileNumber"
                value={formData.mobileNumber || ""}
                maxLength="10"
                onChange={handleChange}
                className={classErr("mobileNumber")}
              />
              {renderError("mobileNumber")}
            </div>

            <div>
              <label>Email ID</label>
              <input
                name="email"
                type="email"
                value={formData.email || ""}
                onChange={handleChange}
                className={classErr("email")}
              />
              {renderError("email")}
            </div>

            <div>
              <label>Pin Code</label>
              <input
                name="pincode"
                maxLength="6"
                value={formData.pincode || ""}
                onChange={handleChange}
                className={classErr("pincode")}
              />
              {renderError("pincode")}
            </div>

            <div>
              {/* <label>Post Office</label>
              <input name="postOffice" value={formData.postOffice || ""} onChange={handleChange} />
              {renderError("postOffice")} */}
              <label>Post Office</label>
              <select
                name="postOffice"
                value={formData.postOffice || ""}
                onChange={handlePostOfficeSelect}
              >
                <option value="">Select Post Office</option>
                {postOfficeList.map((p) => (
                  <option key={p.Name} value={p.Name}>
                    {p.Name}
                  </option>
                ))}
              </select>
            </div>

            <div>
              <label>Bank Account</label>
              <input
                name="bankAccount"
                value={formData.bankAccount || ""}
                onChange={handleChange}
                className={classErr("bankAccount")}
              />
              {renderError("bankAccount")}
            </div>

            <div>
              <label>IFSC</label>
              <input
                name="ifsc"
                placeholder="HDFC0001234 (optional)"
                value={formData.ifsc || ""}
                onChange={handleChange}
                className={classErr("ifsc")}
              />
              {/* <input
                name="ifsc"
                value={formData.ifsc || ""}
                onChange={(e) => setFormData((p) => ({ ...p, ifsc: e.target.value.toUpperCase() }))}
                className={classErr("ifsc")}
                placeholder="HDFC0001234 (optional)"
              /> */}
              {renderError("ifsc")}
            </div>

            <div>
              <label>Bank Branch</label>
              <input name="bankBranch" value={formData.bankBranch || ""} />
            </div>

            <div>
              <label>Bank Name</label>
              <input name="bankName" value={formData.bankName || ""} />
            </div>
          </div>
        </section>

        {/* Address */}
        <section className="form-section">
          <h3 className="section-title">Address</h3>
          <div className="form-grid">
            <div>
              <label>Sub District</label>
              <input
                name="subDistrict"
                value={formData.subDistrict || ""}
                onChange={handleChange}
              />
            </div>

            <div>
              <label>District</label>
              <input
                name="district"
                value={formData.district || ""}
                onChange={handleChange}
              />
              {renderError("district")}
            </div>

            <div>
              <label>State</label>
              <input
                name="state"
                value={formData.state || ""}
                onChange={handleChange}
              />
              {renderError("state")}
            </div>

            <div>
              <label>Country</label>
              <input
                name="country"
                value={formData.country || ""}
                onChange={handleChange}
              />
              {renderError("country")}
            </div>

            <div>
              <label>Full Address</label>
              <textarea
                name="address"
                value={formData.address || ""}
                onChange={handleChange}
                placeholder="Enter full address"
              />
            </div>
          </div>
        </section>

        {/* Other Details */}
        <section className="form-section">
          <h3 className="section-title">Other Details</h3>
          <div className="form-grid">
            <div>
              <label>Marital Status</label>
              <select
                name="maritalStatus"
                value={formData.maritalStatus || ""}
                onChange={handleChange}
              >
                <option value="">Select</option>
                <option>Single</option>
                <option>Married</option>
                <option>Other</option>
              </select>
            </div>

            <div>
              <label>Date of Birth</label>
              <input
                type="date"
                name="dob"
                value={formData.dob || ""}
                onChange={handleChange}
              />
              {renderError("dob")}
            </div>

            <div>
              <label>Date of Joining</label>
              <input
                type="date"
                name="doj"
                value={formData.doj || ""}
                onChange={handleChange}
              />
              {renderError("doj")}
            </div>
          </div>
        </section>

        <div className="form-actions">
          <button
            type="button"
            className="btn-submit"
            onClick={handleSubmit}
            disabled={loadingSubmit}
          >
            {loadingSubmit ? (
              <>
                <FaSpinner className="spin" /> Submitting...
              </>
            ) : (
              "Submit"
            )}
          </button>
        </div>
      </form>
    </div>
  );
};

export default CustomerForm;
